export const TITLE = "Sonstiges";
export const SUBTITLE = "Synchronisierung";
export const LABEL_INITIAL_DOWNLOAD = "Zeitraum für den Erstdownload (Monate)";
export const LABEL_RETENTION = "Offline-Speicherdauer (Monate)";
export const ERROR_POSITIVE_INTEGER = "Bitte eine ganze Zahl größer als 0 eingeben.";
export const ERROR_SAVE = "Speichern fehlgeschlagen. Bitte erneut versuchen.";
export const ERROR_CONFLICT = "Die Einstellungen wurden zwischenzeitlich geändert. Bitte prüfen und erneut speichern.";
export const ERROR_LOAD = "Die Einstellungen konnten nicht geladen werden.";
export const BTN_RETRY = "Erneut versuchen";
